export const staff=[
    {
        name:'Wanter',
        description: 'Owner Of DiamondPE',
        url:'https://cdn.discordapp.com/attachments/1083438619886354513/1084783932572184649/20230313_155120.jpg',
        id:1
    },
    {
        name:'Houssem',
        description: 'Website Dev of DiamondPe',
        url:'https://rukminim1.flixcart.com/image/416/416/k16qzrk0/poster/h/q/t/large-kd-i-cant-do-it-sticker-poster-motivational-poster-original-imafj6hmzdzymmqz.jpeg',
        id:2
    },
    {
        name:'Legend',
        description: 'Manager Of DiamondPE',
        url:'https://cdn.discordapp.com/attachments/1083438619886354513/1084784015300644894/a_9438f1e0ce182a32048bc965180c9af4.png',
        id:3
    },
    {
        name:'IAMDEPRESSED',
        description: 'Helper in DiamondPE',
        url:'https://cdn.discordapp.com/attachments/1083438619886354513/1084784114063904808/a_e6bf99d13d3c81f36115992aa7b971db.png',
        id:4
    },
];